import { penaltyFieldOverlay } from '../../services/aiScoringPenaltyDefaults';
import type { DefaultsSource, SchemaOverlay } from './configSchema';

/**
 * Resolves a schema's `defaultsSource` to the runtime field metadata
 * `SchemaConfigPanel` renders with.
 *
 * The indirection keeps the generic panel from knowing what any particular
 * backend owns: it asks for an overlay, gets field metadata or an "unavailable"
 * reason, and renders accordingly.
 *
 * Never rejects. A panel whose defaults cannot be fetched still has to render
 * its remaining fields — for the penalty screens that means the gate toggles
 * stay usable while the magnitude overrides hide themselves.
 */
export async function resolveSchemaOverlay(source: DefaultsSource): Promise<SchemaOverlay> {
  switch (source.kind) {
    case 'aiScoringPenalties':
      return penaltyFieldOverlay(source.slot);
    default: {
      // Exhaustiveness guard — a new kind must be handled, not silently ignored.
      const unhandled: never = source.kind;
      return { status: 'unavailable', reason: `unknown defaults source: ${String(unhandled)}` };
    }
  }
}
